module.exports = __webpack_public_path__ + "static/media/1.96aab03b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/images/16002/1.jpg
// module id = 495
// module chunks = 0